enum MixPanelEventTypes {
  CLICK = 'Click',
  VIEW = 'View',
  HOVER = 'Hover',
  OTHER = 'Other',
}

export enum PlatformTypes {
  RESTORE = 'RESTORE',
  WELLNESS = 'WELLNESS',
  REMOTE_THERAPY = 'REMOTE_THERAPY',
}

interface IMixPanelEvent {
  platform: PlatformTypes;
  moduleName: string;
  eventType: MixPanelEventTypes;
  eventName: () => string;
  pageName: string;
  extraData?: object | null | undefined;
  category?: string | null | undefined;
  activityType?: string | null | undefined;
  activityName?: string | null | undefined;
  selection?: string | null | undefined;
}

class MixPanelEvent implements IMixPanelEvent {
  constructor(
    public platform: PlatformTypes,
    public moduleName: string,
    public eventType: MixPanelEventTypes,
    public pageName: string,
    public extraData?: object | null | undefined,
    public category?: string | null | undefined,
    public activityType?: string | null | undefined,
    public activityName?: string | null | undefined,
    public selection?: string | null | undefined
  ) {
    this.platform = platform;
    this.moduleName = moduleName;
    this.eventType = eventType;
    this.pageName = pageName;
    this.category = category;
    this.extraData = extraData;
    this.activityType = activityType;
    this.activityName = activityName;
    this.selection = selection;
  }

  eventName(): string {
    const _pageName = this.pageName.replaceAll(' ', '_');
    const _moduleName = this.moduleName.replaceAll(' ', '_');
    return `${this.platform}_${_moduleName}_${_pageName}_${this.eventType}`;
  }
}

const getEventName = (event: MixPanelEvent): string => {
  const _pageName = event.pageName.replaceAll(' ', '_');
  const _moduleName = event.moduleName.replaceAll(' ', '_');
  return `${event.platform}_${_moduleName}_${_pageName}_${event.eventType}`;
};

export { MixPanelEvent, MixPanelEventTypes, getEventName };
